import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BookDemoDialogComponent } from './book-demo-dialog.component';

@Injectable({ providedIn: 'root' })
export class BookDemoService {
  constructor(private dialog: MatDialog) {}

  open(): MatDialogRef<BookDemoDialogComponent> {
    return this.dialog.open(BookDemoDialogComponent, {
      width: '100%',
      maxWidth: '560px',
      panelClass: ['book-demo-dialog-panel'],
      autoFocus: false,
      restoreFocus: true,
    });
  }
}
